/**
 * ═══════════════════════════════════════════════════════════
 * AARKA — Product Info Micro-Interactions
 * Enhances onecount-product with premium animations:
 *  • Trust line injection
 *  • Add-to-cart feedback
 *  • Price flash on variant change
 *  • Smooth accordion transitions
 * ═══════════════════════════════════════════════════════════
 */
(function () {
  'use strict';

  function qs(s, r) { return (r || document).querySelector(s); }
  function qsa(s, r) { return Array.from((r || document).querySelectorAll(s)); }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* Find the product section — try multiple selectors */
    var section = qs('.onecount-product')
               || qs('[data-section-type="main-product"]')
               || qs('section[id*="main"]');
    if (!section) return;

    injectTrustLine(section);
    enhanceAddToCart(section);
    enhancePriceTransition(section);
    enhanceAccordions(section);
  });

  /* ─────────────────────────────────────────────────────────
     1. Trust Line — Now managed via Liquid block (trust_line)
        JS injection kept as fallback only if no Liquid block exists
     ───────────────────────────────────────────────────────── */
  function injectTrustLine(section) {
    /* Liquid-rendered trust line exists — skip JS injection */
    if (qs('.aarka-trust-line')) return;
  }

  /* ─────────────────────────────────────────────────────────
     2. Add-to-Cart Feedback
     ───────────────────────────────────────────────────────── */
  function enhanceAddToCart(section) {
    var btn = qs('.product-form__submit', section);
    if (!btn) btn = qs('.product-form__submit');
    if (!btn) return;

    var btnSpan = qs('span', btn);
    var originalHTML = btnSpan ? btnSpan.innerHTML : btn.innerHTML;

    var form = btn.closest('form');
    if (!form) return;

    form.addEventListener('submit', function () {
      setTimeout(function () {
        btn.classList.add('aarka-added');
        if (btnSpan) {
          btnSpan.innerHTML = '✓ ADDED';
        } else {
          btn.innerHTML = '✓ ADDED';
        }

        setTimeout(function () {
          btn.classList.remove('aarka-added');
          if (btnSpan) {
            btnSpan.innerHTML = originalHTML;
          } else {
            btn.innerHTML = originalHTML;
          }
        }, 2000);
      }, 400);
    });
  }

  /* ─────────────────────────────────────────────────────────
     3. Price Flash on Variant Change
     ───────────────────────────────────────────────────────── */
  function enhancePriceTransition(section) {
    var priceBox = qs('.price__box_wrapper', section);
    if (!priceBox) priceBox = qs('.price__box_wrapper');
    if (!priceBox) return;

    var priceInner = qs('.price', priceBox);
    if (!priceInner) return;

    var observer = new MutationObserver(function () {
      priceBox.classList.add('aarka-price-animating');
      setTimeout(function () {
        priceBox.classList.remove('aarka-price-animating');
      }, 450);
    });

    observer.observe(priceInner, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  /* ─────────────────────────────────────────────────────────
     4. Smooth Accordion Height Transitions
     ───────────────────────────────────────────────────────── */
  function enhanceAccordions(section) {
    var accordions = qsa('.product__accordion details', section);
    if (!accordions.length) {
      accordions = qsa('details.product__accordion', section);
    }
    if (!accordions.length) return;

    accordions.forEach(function (details) {
      var summary = qs('summary', details);
      var content = qs('.accordion__content', details);
      if (!summary || !content) return;

      content.style.overflow = 'hidden';
      content.style.transition = 'max-height 0.35s ease, opacity 0.3s ease';

      summary.addEventListener('click', function (e) {
        e.preventDefault();

        if (details.open) {
          content.style.maxHeight = content.scrollHeight + 'px';
          requestAnimationFrame(function () {
            content.style.maxHeight = '0px';
            content.style.opacity = '0';
          });
          setTimeout(function () {
            details.open = false;
            content.style.maxHeight = '';
            content.style.opacity = '';
            // Refresh ScrollTrigger so downstream sections recalculate positions
            if (window.AARKA && window.AARKA.ScrollTrigger) {
              window.AARKA.ScrollTrigger.refresh();
            }
          }, 350);
        } else {
          details.open = true;
          var h = content.scrollHeight;
          content.style.maxHeight = '0px';
          content.style.opacity = '0';
          requestAnimationFrame(function () {
            content.style.maxHeight = h + 'px';
            content.style.opacity = '1';
          });
          setTimeout(function () {
            content.style.maxHeight = '';
            // Refresh ScrollTrigger so downstream sections recalculate positions
            if (window.AARKA && window.AARKA.ScrollTrigger) {
              window.AARKA.ScrollTrigger.refresh();
            }
          }, 350);
        }
      });
    });
  }
})();
